import axios from 'axios';
const host = process.env.API_URL;
const token = sessionStorage.getItem('token');

export const getFiles = async () => {

    const token = sessionStorage.getItem('token');
    return axios.get(`${host}/api/files`, {
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    }).then((response) => {
        // console.log(response.data.body);
        return { ...response.data.body, path: "" }

    }).catch(error => {
            console.log(error);
    })

}

export const uploadFiles = async (fileNameWithPath, fileSelected) => {
    const token = sessionStorage.getItem('token');
    const encodedFileName = encodeURIComponent(fileNameWithPath.replaceAll(" ", ""))
    return axios.post(`${host}/api/files`,
    {
      'filename': fileNameWithPath
    },
    {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    })
    .then(response => {
      const { url, fileId } = response.data.body;
      return fetch(url, {
        method: 'PUT',
        headers: {
          // 'Content-Type': 'application/octet-stream'
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: fileSelected.input
      });
    })
    .then(response => {
      
      if (response.status === 200) {
        return axios.post(`${host}/api/files/${encodedFileName}/process`, {}, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        })
      } else {
        throw new Error('Upload failed');
      }
    })
    .then(response => {
      if (response.status === 200) {
        const file_size = fileSelected.input.size;
        let retries;
        if (file_size < 25000000) {
          retries = 12
        } else if (25000000 < file_size < 100000000) {
          retries = 30
        } else {
          retries = 180
        }
        return pollUntilFileProcessed(encodedFileName, retries);
      } else {
        throw new Error('Processing failed');
      }
    })
}

const pollUntilFileProcessed = (file_name, maxRetries = 10, retryDelay = 10000) => {
    const host = process.env.API_URL;

    return new Promise((resolve, reject) => {
      const token = sessionStorage.getItem('token');

      const pollFileStatus = (attempt) => {
        if (attempt > maxRetries) {
          console.error(`File took too long to process.`);
          reject(`File ${file_name} took too long to process.`);
          return;
        }

        axios.get(`${host}/api/files/${file_name}/status`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        })
          .then(response => {
            const fileStatus = response.data.body.status;
            console.log(`File status: ${fileStatus}`)
            if (fileStatus === "processed") {
              console.log(`File ${file_name} has been processed successfully.`);
              resolve();
            } else {
              console.log(`File ${file_name} is still being processed. Retrying in ${retryDelay / 1000} seconds...`);
              setTimeout(() => {
                pollFileStatus(attempt + 1);
              }, retryDelay);
            }
          })
          .catch(error => {
            console.error(`Error while polling file status for ${file_name}: ${error}`);
            console.log(`Retrying in ${retryDelay / 1000} seconds...`);
            setTimeout(() => {
              pollFileStatus(attempt + 1);
            }, retryDelay);
          });
      };

      pollFileStatus(1);
    })
  }

export const getMergeAttributes = async (files) => {
  const token = sessionStorage.getItem('token');
  return axios.get(`${host}/api/files/${encodeURIComponent(files[0])}/merge_attributes?file_id2=${encodeURIComponent(files[1])}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    }})
    .then(response => {
      const mergeAttributes = response.data.body.merge_attributes;
      return mergeAttributes;
    })
    .catch(error => {
      console.error(error);
    });
}

export const getDiffCalculation = async (data) => {
  const token = sessionStorage.getItem('token');
  try {
    const job_id = await axios.post(`${host}/api/maps/evaluate_difference`, JSON.stringify(data),
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      }
    ).then(response => {
      return response.data.body.id;

    });
    const job = await pollUntilJobReady(job_id, 60);
    return {
      "url": job.metadata.url,
      "datasetName": job.metadata.dataset_filename
    }
  } catch (error) {
    console.error(`Error running diff calculation.`);
    throw error;
  }
}

const pollUntilJobReady = (job_id, maxRetries = 10, retryDelay = 10000) => {
  const host = process.env.API_URL;

  return new Promise((resolve, reject) => {
    const token = sessionStorage.getItem('token');

    const pollJobStatus = (attempt) => {
      if (attempt > maxRetries) {
        console.error(`Job took too long to process.`);
        reject(`Error processing file. Please contact support with job ID ${job_id}.`);
        return;
      }

      axios.get(`${host}/api/jobs/${job_id}/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      })
        .then(response => {
          const jobStatus = response.data.status;
          console.log(`Job status: ${jobStatus}`)
          if (jobStatus === "complete") {
            resolve(response.data);
          } else {
            console.log(`Job ${job_id} is not complete. Retrying in ${retryDelay / 1000} seconds...`);
            setTimeout(() => {
              pollJobStatus(attempt + 1);
            }, retryDelay);
          }
        })
        .catch(error => {
          console.error(`Error while polling job status for ${job_id}: ${error}`);
          console.log(`Retrying in ${retryDelay / 1000} seconds...`);
          setTimeout(() => {
            pollJobStatus(attempt + 1);
          }, retryDelay);
        });
    };

    pollJobStatus(1);
  })
}

export const getChartAttributes = async (files) => {
  const token = sessionStorage.getItem('token');
  return axios.get(`${host}/api/files/${encodeURIComponent(files[0])}/attributes`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    }})
    .then(response => {
      const chartAttributes = response.data.attributes;
      return chartAttributes;
    })
    .catch(error => {
      console.error(error);
    });
}

